// extracted by mini-css-extract-plugin
export default {"box":"DescriptionCard_box__YM7KL"};